import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/eu-stock/[symbol]/EuStockDetailClient.tsx");
